import { render, staticRenderFns } from "./UnresolvedTransactionsCard.vue?vue&type=template&id=48d8885e&scoped=true&"
import script from "./UnresolvedTransactionsCard.vue?vue&type=script&lang=js&"
export * from "./UnresolvedTransactionsCard.vue?vue&type=script&lang=js&"
import style0 from "./UnresolvedTransactionsCard.vue?vue&type=style&index=0&id=48d8885e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d8885e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCardTitle,VCol,VDataTable,VDivider,VIcon,VProgressLinear,VRow,VTooltip})
